import React from "react";

import MapWinRate from "./MapWinRate.js";

export default function StatsTopMaps(props) {
  if (props) {
    return (
      <div className="stats-top-civs animate__animated animate__pulse">
        {props.statsByMap.slice(0, 3).map((map) => {
          return <MapWinRate key={map.map} {...map} />;
        })}
      </div>
    );
  } else {
    return <div className="stats-top-civs">No data for maps</div>;
  }
}
